import React from 'react';

import ProductSelection from "./ProductSelection"
import ScenarioSelection from "./ScenarioSelection"
import SoloView3D from "./SoloView3D"
import DetectSwipe from '../helpers/DetectSwipe';

export default function Bottombar({ roofProduct, roofColor, setRoofProduct, setRoofColor,
                                    facadeProduct, facadeColor, setFacadeProduct, setFacadeColor,
                                    productCategory, setProductCategory, scenario, setScenario,
                                    showImageGallery, setShowImageGallery, isSidebarVisible, setIsSidebarVisible, menuView, setMenuView, showActiveBullet}: any) {

  const [showProductTab, setShowProductTab] = React.useState(true);

  React.useEffect(() => {
    if (showActiveBullet) {
      setIsSidebarVisible(false)
    }
  }, [showActiveBullet, setIsSidebarVisible]);

  const setLocalShowProductTab = (value : boolean) => {
    setIsSidebarVisible(true);
    setShowProductTab(value);
  }

  const SwipeShowSidebar = () => {
    setIsSidebarVisible(true)
  }
  const SwipeHideSidebar = () => {
    setIsSidebarVisible(false)
  }

  DetectSwipe("bar-swipe",SwipeShowSidebar, SwipeHideSidebar);

  return (
    <div className={`full-bottombar-main-container ${showImageGallery ? '' : 'visible'}`}>

      <div className={`bottombar-main-container ${isSidebarVisible ? '' : 'collapsed'} ${showImageGallery ? '' : 'visible'}`}>
        
        <div className="bottombar-main-container-header">
          <div id='bar-swipe' className='bottombar-toggle' onClick={() => setIsSidebarVisible(!isSidebarVisible)}>
              <div className='bottombar-toggle-icon'/>
          </div>
          { menuView !== "VISTA 3D" &&
            <div className='bottombar-titles-container'>
              <div className={`bottombar-titles ${showProductTab ? 'selected' : ''}`} onClick={() => setLocalShowProductTab(true)}>Productos</div>
              <div className={`bottombar-titles ${!showProductTab ? 'selected' : ''}`} onClick={() => setLocalShowProductTab(false)}>Proyectos</div>
            </div>
          }
          { menuView !== "VISTA 3D" &&
            <div className={`bottombar-titles-container ${isSidebarVisible ? '' : 'hidden'}`}>
              <div className={`bottombar-titles-underline ${showProductTab ? 'selected' : ''}`}/>
              <div className={`bottombar-titles-underline ${!showProductTab ? 'selected' : ''}`}/>
            </div>
          }
        </div>

        { menuView !== "VISTA 3D" &&
          <div className={`bottombar-config-container ${isSidebarVisible ? '' : 'hidden'}`}>
          { showProductTab ?
            <ProductSelection roofProduct={roofProduct} setRoofProduct={setRoofProduct} roofColor={roofColor} setRoofColor={setRoofColor}
                              facadeProduct={facadeProduct} setFacadeProduct={setFacadeProduct} facadeColor={facadeColor} setFacadeColor={setFacadeColor}
                              scenario={scenario} setScenario={setScenario} productCategory={productCategory} setProductCategory={setProductCategory}
                              showImageGallery={showImageGallery} setShowImageGallery={setShowImageGallery} setMenuView={setMenuView}/>
          :
            <ScenarioSelection scenario={scenario} setScenario={setScenario}/>
          }
        </div>
        }

        {  menuView === "VISTA 3D" &&
          <SoloView3D product={productCategory === "roof" ? roofProduct : facadeProduct} color={productCategory === "roof" ? roofColor : facadeColor} setMenuView={setMenuView} isSidebarVisible={isSidebarVisible} showActiveBullet={showActiveBullet}/>
        }
      </div>

    </div>
  );
}
